module.exports = __webpack_public_path__ + "img/awake-bot-avatar.8b8bfd04.png";